<template>
  <div class="accordion">
    <button @click="toggleAccordion()" class="" :aria-expanded="isOpen || show" :aria-controls="`collapse`">

      <div class="accordion-title">
        <span>
          <slot name="title" class="accordion-title" />
        </span>
      </div>

      <svg xmlns="http://www.w3.org/2000/svg" width="15.123" height="7.773" viewBox="0 0 15.123 7.773" :class="{ 'close': !isOpen }" v-if="!show">
        <path id="Union_8" data-name="Union 8" d="M6.683,7.046,0,14.091ZM0,0,6.67,7.06Z" transform="translate(0.515 7.228) rotate(-90)" fill="#222" stroke="#2c2c2c" stroke-width="1.5" />
      </svg>

    </button>
    <transition name="fade" appear>
      <div v-show="isOpen || show" :id="`collapse`" class="accordion-container">
        <slot name="content" />
      </div>
    </transition>
  </div>
</template>
  
<script>
export default {
  props: {
    show: {
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
    }
  },
  methods: {
    toggleAccordion () {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

.accordion-container {
  margin-top: 24px;
  position: relative;
}

.accordion-title {
  text-align: left;
  font-family: "Paralucent Demi";
  padding-left: 10px;
  margin-left: -10px;

  span {
    font-family: "Paralucent Demi";
  }
}

.accordion {
  position: relative;
  margin-bottom: 20px;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;

    svg.close {
      transform: rotate(180deg);
    }
  }

  &:not(:last-child)::after {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #0B3148;
    content: "";
  }

  input {
    width: 100%;
    border: none;
    background-color: #F5F5F5;
    height: 50px;
    border-radius: 25px;
    padding-left: 25px;
    padding-right: 50px;

    &::placeholder {
      font-weight: 500;
      font-family: Paralucent;
      color: #B7B7B7;
      font-size: 14px;
    }
  }

  .location-search-icon {
    position: absolute;
    top: 16.5px;
    right: 20px;
  }
}
</style>